"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mark;
exports.resource = resource;

var _noop2 = _interopRequireDefault(require("lodash/noop"));

var _debug = _interopRequireDefault(require("debug"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var info = (0, _debug.default)('rrf:profile');
var win;

try {
  var nodeRequire = module["require"].bind(module);
  win = nodeRequire('perf_hooks');
} catch (e) {}

try {
  win = window;
} catch (e) {}

var perf = win && win.performance;

function mark(marker) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!_debug.default.enabled('rrf:*') || !_debug.default.enabled('rrf:profile') || !perf) {
    return _noop2.default;
  }

  try {
    var now = perf.now();
    var start = "@rrf/".concat(marker, "-").concat(now);
    perf.mark(start);

    if (context) {
      info("".concat(marker, ".").concat(context));
    }

    return function () {
      perf.measure("@rrf/".concat(marker), start);
    };
  } catch (err) {
    return _noop2.default;
  }
}

function resource(marker) {
  if (!_debug.default.enabled('rrf:*') || !_debug.default.enabled('rrf:profile') || !perf) {
    return _noop2.default;
  }

  try {
    var now = perf.now();
    var start = "@rrf.load/".concat(marker, "-").concat(now);
    perf.mark(start);
    return function () {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      perf.measure("@rrf.load/".concat(marker, ".|").concat(count, "|"), start);
    };
  } catch (err) {
    return _noop2.default;
  }
}

if (win) {
  win.rrfStats = function () {
    if (!_debug.default.enabled('rrf:*') || !_debug.default.enabled('rrf:profile') || !perf) {
      return console.log("Profiling not enabled. Enable using `debug.enable('rrf:profile').`");
    }

    var getMarks = function getMarks(_ref) {
      var name = _ref.name;
      return name.indexOf('@rrf/') === 0;
    };

    var getLoads = function getLoads(_ref2) {
      var name = _ref2.name;
      return name.indexOf('@rrf.load/') === 0;
    };

    var duration = function duration(stats, _ref3) {
      var duration = _ref3.duration,
          name = _ref3.name;

      if (stats[name]) {
        stats[name].push(duration);
      } else {
        stats[name] = [duration];
      }

      return stats;
    };

    var logStats = function logStats(grouped) {
      console.group("Redux Firestore Profiling");
      console.table(Object.keys(grouped).map(function (name) {
        var arr = grouped[name];
        var sum = arr.reduce(function (a, b) {
          return a + b;
        }, 0);
        return _defineProperty({}, name, {
          mean: parseFloat((sum / arr.length).toFixed(2)),
          samples: arr.length,
          min: parseFloat(arr.reduce(function (a, b) {
            return a < b ? a : b;
          }, arr[0]).toFixed(2)),
          max: parseFloat(arr.reduce(function (a, b) {
            return a > b ? a : b;
          }, arr[0]).toFixed(2)),
          sum: parseFloat(sum.toFixed(2))
        });
      }).reduce(function (result, item) {
        return _objectSpread(_objectSpread({}, result), item);
      }));
      console.groupEnd();
    };

    var marks = performance.getEntriesByType('measure').filter(getMarks).reduce(duration, {});
    logStats(marks);

    var phases = function (last, phase) {
      return function (_ref5) {
        var startTime = _ref5.startTime,
            duration = _ref5.duration,
            name = _ref5.name;

        if (last + 16 <= startTime) {
          phase++;
        }

        var item = {
          name: name,
          start: parseFloat(startTime.toFixed(2)),
          phase: phase,
          duration: parseFloat(duration.toFixed(2)),
          loaded: (/\|(\d+)\|/g.exec(name) || [0, 0])[1]
        };
        last = startTime;
        return item;
      };
    }(false, 0);

    var group = function group(arr, prop) {
      return arr.reduce(function (stats, _ref6) {
        var phase = _ref6.phase,
            name = _ref6.name,
            start = _ref6.start,
            duration = _ref6.duration,
            loaded = _ref6.loaded;

        if (!stats[phase]) {
          stats[phase] = {};
        }

        stats[phase][name] = {
          start: start,
          duration: duration,
          loaded: loaded
        };
        return stats;
      }, {});
    };

    var logPhases = function logPhases(phases) {
      var last = 0;
      console.group("Firestore Collection Loads");
      Object.keys(phases).forEach(function (key) {
        var start = Object.values(phases[key]).reduce(function (num, _ref7) {
          var start = _ref7.start;
          return Math.min(num, start);
        }, Number.MAX_VALUE);
        console.group("Phase ".concat(key, " +").concat(Math.floor(start - last), "ms"));
        console.table(phases[key]);
        console.groupEnd();
        last = start;
      });
      console.groupEnd();
    };

    var loads = performance.getEntriesByType('measure').filter(getLoads).map(phases);
    logPhases(group(loads, 'phase'));
  };
}